let calculateMarkerArrowAngle = function calculateMarkerArrowAngle(lat1, lon1, lat2, lon2) {
  let longDiff = lon2 - lon1;
  let y        = Math.sin(longDiff) * Math.cos(lat2);
  let x        = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(longDiff);

  return ( toDegrees( Math.atan2( y, x ) ) + 360 ) % 360;
};

function toDegrees (angle) {
  return angle * (180 / Math.PI);
}

function midpoint (lat1, long1, lat2, long2, per, counter) {
  return [lat1 + (lat2 - lat1) * per, long1 + (long2 - long1) * per, calculateMarkerArrowAngle(lat1, long1, lat2, long2), counter];
}

export const splitRoute = (route, gap) => {

  let splittedRoute = [],
    lastAngle = 0,
    counter = 0;

  route.forEach(function(point, index){

    // Step 1. Get distance between points
    if (typeof route[(index+1)] != 'undefined') {

      let nextPoint = route[(index+1)];

      point.push(calculateMarkerArrowAngle(point[0], point[1], nextPoint[0], nextPoint[1]), counter);
      splittedRoute.push(point);

      // Step 2. Calculate route
      let fullDistance = getDistanceBetweenPoints(point[0], point[1], nextPoint[0], nextPoint[1]);

      // Step 3. Create midpoints
      if (fullDistance >= gap) {

        let totalSteps = Math.floor(fullDistance / gap),
          percentsStep = Math.round(100 / (totalSteps+1)),
          percent = percentsStep;

        for (let i = 0; i < totalSteps; i++) {
          counter++;
          splittedRoute.push(midpoint(point[0], point[1], nextPoint[0], nextPoint[1], percent / 100, counter));
          percent += percentsStep;
        }

      }

    } else {

      if (typeof splittedRoute[splittedRoute.length - 1][2] != 'undefined') {
        point.push(splittedRoute[splittedRoute.length - 1][2]);
      } else {
        point.push(0);
      }
      point.push(counter);
      splittedRoute.push(point);

    }

    counter++;


  });

  return splittedRoute;

};

function getDistanceBetweenPoints(lat1, lon1, lat2, lon2) {
  let R = 6371; // Radius of the earth in km
  let dLat = deg2rad(lat2-lat1);  // deg2rad below
  let dLon = deg2rad(lon2-lon1);
  let a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon/2) * Math.sin(dLon/2)
  ;
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c * 1000; // Distance in metres
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

function calculateAngle(panoramas, index) {

  let offset = 3,
    angleDiff = 0;

  let angles = [];

  let i = index;

  for (let n = i; n < (index + offset); n++) {

    if (typeof panoramas[n + 1] != 'undefined') {

      angles.push(
        angleDiff = calculateAngleDiff(
          [panoramas[n].originalLat, panoramas[n].originalLng],
          [panoramas[n + 1].originalLat, panoramas[n + 1].originalLng]
        )
      );
    }

  }

  if (angles.length === 0) return angleDiff;

  return angles.reduce(function(a, b) { return a + b; }) / angles.length;

}

function calculateAngleDiff(p1, p2) {
  return Math.atan2(p2[1] - p1[1], p2[0] - p1[0]) * 180 / Math.PI;
}

function distanceBetween(point1, point2) {
  let rad = Math.PI / 180,
      lat1 = point1[1] * rad,
      lat2 = point2[1] * rad,
      a = Math.sin(lat1) * Math.sin(lat2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.cos((point2[0] - point1[0]) * rad);

  return 6378137 * Math.acos(Math.min(a, 1));
}

/**
 * Counts points (line) distance
 *
 * @param points
 * @returns {number}
 */
export const countPointsDistance = (points) => {

  let distance = 0;

  for (let i = 0; i < points.length - 1; i++) {
    distance += distanceBetween(points[i], points[i + 1]);
  }

  return distance;
};

/**
 * Counts points (line) distance time
 *
 * @param distance
 * @returns {number}
 */
export const countPointsTimeByDistance = (distance) => {
  let distancePerTime = 1.12;
  return Math.round(distance / distancePerTime);
};

export const normalizeRoutePathPoints = (routePath, points) => {

  let normalizedPoints = points.map(fixCoordinates);

  if (!arePointsEqual(routePath.from.coordinates, points[0])) {
    normalizedPoints.unshift(
      fixCoordinates(routePath.from.coordinates)
    );
  }

  if (!arePointsEqual(routePath.to.coordinates, points[points.length - 1])) {
    normalizedPoints.push(
      fixCoordinates(routePath.to.coordinates)
    );
  }

  return points;
};

function fixCoordinates(point) {
  let truncate = function truncator(numToTruncate, intDecimalPlaces) {
    let numPower = Math.pow(10, intDecimalPlaces); // "numPowerConverter" might be better
    //double tilde: http://stackoverflow.com/a/4055675/1028230
    return ~~(numToTruncate * numPower)/numPower;
  };

  return [
    truncate(point[0], 6),
    truncate(point[1], 6)
  ];
}

function arePointsEqual(point1, point2) {
  return (point1[0] === point2[0] && point1[1] === point2[1]);
}